<template>
  <div class="text--primary">
    <v-row dense>
      <v-col cols="12" sm="5">
        <span class="caption font-weight-bold">Site</span>
        <div>
          {{ fornecedor.fornecedor.site | naoInformado }}
          <v-btn icon :href="site" target="_blank" v-if="site">
            <v-icon small>
              mdi-open-in-new
            </v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" sm="5">
        <span class="caption font-weight-bold">Observações internas</span>
        <div>
          <px-show-large-text :large-text="fornecedor.observacoesInternas"/>
        </div>
      </v-col>
      <v-col cols="12" sm="2">
        <span class="caption font-weight-bold">Editar cotações</span>
        <div>
          <px-switch-tooltip
            v-model="fornecedor.permiteEdicaoCotacao"
            disabled="true"
            tooltip="Habilita a edição das respostas submetidas por este fornecedor no<br>
              processo de cotação, desde que não possua negociação em aberto."/>
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="5">
        <span class="caption font-weight-bold">Código interno</span>
        <div>
          {{ fornecedor.codigoInterno | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="7">
        <span class="caption font-weight-bold">Código interno transportadora</span>
        <div>
          {{ fornecedor.codigoTransportadora | naoInformado }}
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="5">
        <span class="caption font-weight-bold">CNAE principal</span>
        <div v-if="fornecedor.fornecedor.atividadePrincipal">
          {{ fornecedor.fornecedor.atividadePrincipal.codigoCnae }} -
          {{ fornecedor.fornecedor.atividadePrincipal.descricao }}
        </div>
        <div v-else>
          Não informado
        </div>
      </v-col>
      <v-col cols="12" sm="7" >
        <span class="caption font-weight-bold">CNAEs secundários</span>
        <template v-for="cnae in fornecedor.fornecedor.atividadesSecundarias">
          <div :key="cnae">
            {{ cnae.codigoCnae }} -
            {{ cnae.descricao }}
          </div>
        </template>
        <div v-if="!fornecedor.fornecedor.atividadesSecundarias.length">
          Não informado
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    fornecedor: Object,
  },
  computed: {
    site() {
      if (!this.fornecedor.fornecedor.site) {
        return null;
      }
      if (this.fornecedor.fornecedor.site.includes('http://')
        || this.fornecedor.fornecedor.site.includes('https://')) {
        return this.fornecedor.fornecedor.site;
      }
      return `https://${this.fornecedor.fornecedor.site}`;
    },
  },
};
</script>
